import { buildPaginatedUrl } from '../LeanLinkService';

const FRONTEND_MOUNT_POINT = '';
const buildPath = (path = '') => `${FRONTEND_MOUNT_POINT}${path}`;

const Routes = {
  admin: {
    generic: () => buildPath('/admin/generic'),
    users: {
      budget: ({ id }) => buildPath(`/admin/budget/${id}`),
      create: () => buildPath('/admin/users/create'),
      edit: ({ id }) => buildPath(`/admin/users/${id}`),
      list: () => buildPath('/admin/users'),
    },
    budget: {
      list: () => buildPath('/admin/budget'),
    },
    terms: {
      list: () => buildPath('/admin/terms'),
      create: () => buildPath('/admin/terms/create'),
      edit: ({ id }) => buildPath(`/admin/terms/${id}`),
    },
    documentTemplates: {
      list: () => buildPath('/admin/document-templates'),
      create: () => buildPath('/admin/document-templates/create'),
      edit: ({ id }) => buildPath(`/admin/document-templates/${id}`),
      preview: ({ id }) => buildPath(`/admin/document-templates/${id}/preview`),
    },
    competencies: {
      list: () => buildPath('/admin/competencies'),
    },
    events: {
      list: () => buildPath('/admin/events'),
    },
    recruitmentStatuses: () => buildPath('/admin/recruitment-statuses'),
    subscriptions: () => buildPath('/admin/subscriptions')
  },
  home: () => buildPath('/'),
  bookings: {
    create: () => buildPath('/bookings/create'),
    edit: ({ bookingId }) => buildPath(`/bookings/edit/${bookingId}`),
    clone: ({ id }) => buildPath(`/bookings/clone/${id}`),
    rebook: ({ id }) => buildPath(`/bookings/rebook/${id}`),
    list: () => buildPath('/bookings/'),
    view: ({ bookingId }) => buildPath(`/bookings/${bookingId}`),
    weekly: () => buildPath('/bookings/weekly'),
  },
  customers: {
    list: () => buildPath('/customers'),
    create: () => buildPath('/customers/create'),
    createWithOwner: ({ ownerId }) => buildPath(`/customers/create/${ownerId}`),
    view: ({ id, listId }) => buildPath(`/customers/${id}${listId ? `?listId=${listId}` : ''}`),
  },
  inquiries: {
    list: () => buildPath('/inquiries'),
    create: () => buildPath('/inquiries/create'),
    edit: ({ id }) => buildPath(`/inquiries/edit/${id}`),
    createWithCustomer: ({ customerId }) => buildPath(`/inquiries/create?customerId=${customerId}`),
  },
  agreements: {
    cloneCustomer: ({ agreementId }) => buildPath(`/agreements/create/${agreementId}?type=customer`),
    cloneResource: ({ agreementId }) => buildPath(`/agreements/create/${agreementId}?type=resource`),
    createCustomer: () => buildPath('/agreements/create?type=customer'),
    createResource: () => buildPath('/agreements/create?type=resource'),
    editCustomer: ({ agreementId }) => buildPath(`/agreements/edit/${agreementId}?type=customer`),
    editResource: ({ agreementId }) => buildPath(`/agreements/edit/${agreementId}?type=resource`),
    list: () => buildPath('/agreements'),
    listCustomer: () => buildPath('/agreements?type=customer'),
    listResource: () => buildPath('/agreements?type=resource'),
    view: ({ agreementId }) => buildPath(`/agreements/view/${agreementId}`),
  },
  resources: {
    create: () => buildPath('/resources/create'),
    view: ({ id, listId }) => buildPath(`/resources/${id}${listId ? `?listId=${listId}` : ''}`),
    sms: (options = {}) => buildPath(buildPaginatedUrl('/resources/sms', options)),
    schedule: () => buildPath('/resources/schedule'),
    list: () => buildPath('/resources'),
    resourceImport: () => buildPath('/resources/import'),
    scheduleTable: ({ id }) => buildPath(`/resources/${id}/schedule-table`),
    qualifyingDeductions: ({ id }) => buildPath(`/resources/${id}/qualifying-deductions`),
    pipeline: () => buildPath('/resources-pipeline'),
  },
  recruitment: {
    list: () => buildPath('/recruitments'),
    create: () => buildPath('/recruitments/create'),
    clone: ({ id }) => buildPath(`/recruitments/copy/${id}`),
    edit: ({ id }) => buildPath(`/recruitments/edit/${id}`),
    dashboard: () => buildPath('/recruitments/dashboard'), 
  },
  projects: {
    list: () => buildPath('/projects'),
    create: () => buildPath('/projects/create'),
    edit: () => buildPath('/projects/edit'),
    details: ({ id }) => buildPath(`/projects/details/${id}`),
  },
  candidates: {
    create: () => buildPath('/candidates/create'),
    list: () => buildPath('/candidates'),
  },
  lists: {
    resources: () => buildPath('/lists/resources'),
    viewResources: ({ id }) => buildPath(`/lists/resources/${id}`),
    customers: () => buildPath('/lists/customers'),
    viewCustomers: ({ id }) => buildPath(`/lists/customers/${id}`),
  },
  contacts: {
    view: ({ id }) => buildPath(`/persons/${id}`),
    list: () => buildPath(`/persons`),
  },
  services: {
    view: () => buildPath('/services'),
  },
  economy: {
    invoice: () => buildPath('/economy/invoice'),
    list: () => buildPath('/economy'),
    listInvoices: () => buildPath('/economy/invoices'),
    listPayments: () => buildPath('/economy/payments'),
    previewPayment: () => buildPath('/economy/preview-payment'),
  },
  employments: {
    create: () => buildPath('/employments/create'),
    createResource: ({ resourceId }) => buildPath(`/employments/create/resource/${resourceId}`),
    list: () => buildPath('/employments'),
    view: ({ id }) => buildPath(`/employments/${id}`),
  },
  internalAdmin: {
    listStaffingCompanyGroups: () => buildPath('/internal-admin/staffing-company-groups'),
    viewStaffingCompanyGroup: ({ staffingCompanyGroupId }) => buildPath(`/internal-admin/staffing-company-groups/${staffingCompanyGroupId}`),
    createStaffingCompanyGroup: () => buildPath(`/internal-admin/staffing-company-groups/create`),
    competencies: () => buildPath('/internal-admin/competencies'),
    createCompetency: () => buildPath('/internal-admin/competencies/create'),
    editCompetency: ({ competencyId }) => buildPath(`/internal-admin/competencies/${competencyId}/edit`),
    profileItems: () => buildPath('/internal-admin/profile-items'),
    translations: () => buildPath('/internal-admin/translations')
  },
  resetPassword: () => buildPath('/reset-password'),
  events: () => buildPath('/events'),
  files: ({ id }) => buildPath(`/api/files/${id}`),
  login: () => buildPath('/login'),
  profile: () => buildPath('/profile'),
  sms: () => buildPath('/sms'),
  timeReports: () => buildPath('/time-reports'),
  twoFactor: () => buildPath('/twoFactor'),
};
export default Routes;
